export default {
  install(Vue) {

    const audios = {};     // Guarda todos os áudios carregados
    let onErrorCallback = null;

    function loadAudio(name, fileBaseName, loop = false) {
      const audio = new Audio();
      const mp3 = `./audios/${fileBaseName}.mp3`;
      const ogg = `./audios/${fileBaseName}.ogg`;

      audio.src = mp3;
      audio.loop = loop;

      audio.onerror = () => {
        console.warn(`MP3 falhou -> tentando OGG`);
        audio.src = ogg;

        audio.onerror = () => {
          console.error(`Falhou OGG também`);
          if (onErrorCallback) onErrorCallback({ name, mp3, ogg });
        };
      };

      audios[name] = audio;
      return audio;
    }

    function play(name) {
      const audio = audios[name];
      if (!audio) return;

      audio.play().catch(err => {
        console.error("Erro ao tocar:", err);
        if (onErrorCallback) onErrorCallback({ name });
      });
    }

    function pause(name) {
      const audio = audios[name];
      if (!audio) return;

      audio.pause();
      audio.currentTime = 0;
    }

    Vue.prototype.$audio = {
      load: loadAudio,
      play,
      pause,
      onError(cb) {
        onErrorCallback = cb;
      }
    };
  }
};
